import BaseModel from 'src/model/base.model';
import ProductDetailsModel, {
  IExtraProduct,
  IWarehouse
} from './productdetails.model';
import LocationModel from './location.model';
import WarehouseDefaultModel from './warehouseDefault.model';

class ProductModel extends BaseModel {
  public available?: boolean | null = true;
  public id?: number = 0;
  public productNumber: string = '';
  public name?: string = '';
  public replacementMfc?: string = '';
  public replacementPart?: string = '';
  public alternateProductNumber?: string = '';
  public alternateProductManufacturer?: string = '';
  public oemProductNumber?: string = '';
  public oemProductManufacturer?: string = '';
  public description: string = '';
  public manufacturerCode: string = '';
  public imageUrls: string[] = [];
  public subcategories: any[] = [];
  public partnerPrice: number = 0;
  public retailPrice: number = 0;
  public active: boolean = true;
  public inStock: boolean = true;
  public partSeries?: string = '';
  public diagramReferenceNumber?: string;
  public diagramOwner?: number;
  public productDetails?: ProductDetailsModel;
  public productDetailsState?: 'pending' | 'loading' | 'loaded' | 'none';
  public isAvailable?: boolean | null = null;
  public discountInfo?: IDiscountInfo;
  public favorite?: boolean; // Used on top products and frequent
  public isFavorite?: boolean; // Used on part details
  public idFavoriteItem?: number;
  public listItem?: IListItem[];
  public replacedMfc?: string;
  public replacedPart?: string;
  public replacement?: string;
  public featured?: boolean;
  public specialOrder: boolean;
  public state: string;
  public stateDescription: string;
  public extraCharges: number = 0;
  public hasExtraCharges: boolean;
  public score: number;
  public warehouse: WarehouseDefaultModel[];
}

export interface IDiscountInfo {
  discountAmount: number;
  discountPercentage: number;
  priceAfterDiscount: number;
  priceBeforeDiscount: number;
  validUntilDate: string;
}

export interface IListItem {
  idItem: number;
  idList: number;
}

export interface IPartModel {
  images: string[];
  name: string;
  replacementMfc: string;
  replacementPart: string;
  alternateProductNumber?: string;
  alternateProductManufacturer?: string;
  oemProductNumber?: string;
  oemProductManufacturer?: string;
  productNumber: string;
  manufacturerCode: string;
  description: string;
  price: number;
  msrp: number;
  warehouseCode: string;
  warehouseQty: number;
  warehouseDesc: string;
  inStock: boolean;
  state: string;
  stateDescription: string;
  supplierQuantity: string | number;
  extraProducts: IExtraProduct[];
  extraTotalAmount: number;
  replacedMfc?: string;
  replacedPart?: string;
  specialOrder: boolean;
  locations: LocationModel[];
  warehouses: IWarehouse[];
}

export default ProductModel;
